import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { MontantAnnuel } from '../models/MontantAnnuel';

@Component({
  selector: 'app-montant-annuel',
  templateUrl: './montant-annuel.component.html'
})
export class MontantAnnuelComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() montantAnnuel : MontantAnnuel;

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_MontantAnnuel';
  }
}
